module.exports = __webpack_public_path__ + "static/media/icon-wheelchair-light.2d98ee9e.svg";